import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Form, Button, Row, Col, Toast } from 'react-bootstrap'
import { connect } from 'react-redux';
import { _HttpServices } from '../../_services/_HttpServices'
import { IoIosClose,IoMdDoneAll} from "react-icons/io"
import Loader from "../../components/Loader";
import {Footer} from '../../components/Footer'


const MyProfile = () => {
    const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [values, setValues] = useState(loggedInUserData);
    const [errors, setErrors] = useState({});
    const [roles, setRoles] = useState([]);
    const [showToaster, setShowToaster] = useState(false);
    const [validate, setValidated] = useState(false);
    const [addSubmitDisabled, setSubmitAddDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const handleChange = (event) => {
        event.persist();
        if (values.FirstName.length > 0 && values.LastName.length > 0)
        setSubmitAddDisabled(false)
    else if (values.FirstName.length === 0 && values.LastName.length === 0)
        setSubmitAddDisabled(true)
    else
        setSubmitAddDisabled(true)
        restrictFileds(event.target.name, event.target.value);

    }
    useEffect(() => {
        getRoles();
    }, []);
    //  restrict fields
    const restrictFileds = (name, value) => {
        if (
            name === "ContactNumber" ||
            name === "ZIPCode" || name === "FirstName" || name === 'LastName'
            || name === 'UserName'
        ) {
            if (name === "ContactNumber" ||
                name === "ZIPCode") {
                const re = /^[0-9\b]+$/;
                if (value === "" || re.test(value)) {
                    setValues((values) => ({
                        ...values,
                        [name]: value,
                    }));
                }
            }
            if (name === 'FirstName' || name === 'LastName') {
                const re = /^[a-zA-Z \b]+$/;
                if (value === "" || re.test(value)) {
                    setValues((values) => ({
                        ...values,
                        [name]: value,
                    }));
                }
            }
            if (name === 'UserName') {
                const re = /^[a-zA-Z]*$/
                if (value === "" || re.test(value)) {
                    setValues((values) => ({
                        ...values,
                        [name]: value,
                    }));
                }
            }
        } else {
            setValues((values) => ({
                ...values,
                [name]: value,
            }));
            setValues((values) => ({
                ...values,
                CreatedBy: loggedInUserData.UserName,
                ModifiedBy: loggedInUserData.UserName,
            }));
        }
    }
    // 

    async function getRoles() {
        await _HttpServices
            .getData("Api/User/GetRoles")
            .then((data) => {
                setRoles(data.data);
            })
            .catch((e) => console.log(e));
    }
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()

        } else {
            if (values.FirstName !== "" && values.LastName !== "") {
                event.preventDefault();
                if(values.ZIPCode.length > 0 && values.ZIPCode != 0){
                    if(values.ZIPCode.length < 5){
                      errors.ZIPCode = "Please check entered Zip Code minimum length should be 5"
                      // alert("2")
                      setValidated(true)
                      return
                    }
                  }
                setValues((values) => ({
                    ...values,
                    CreatedBy: loggedInUserData.UserName,
                    ModifiedBy: loggedInUserData.UserName,
                }));
                setLoading(true);
                _HttpServices
                    .postData("Api/User/UpdateUser", values)
                    .then((data) => {
                        if (data.data === "") {
                            localStorage.setItem("userData", data.config.data)
                            setShowToaster(true);
                            setTimeout(()=>{
                                history.goBack();
                            },3000)
                            setLoading(false);
                            setValidated(false);
                        }
                    })
                    .catch((e) => {
                        setLoading(false);
                    });
            }
        }
        setValidated(true)
        setSubmitAddDisabled(true);
    };

    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">My Profile</h2>
            </div>
            <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Body>Details updated successfully</Toast.Body>
            </Toast>
            <div className="card pt-2 pb-3">
                <div className="card-body">
                    <Form validated={validate} onSubmit={(e) => handleSubmit(e)} noValidate>
                        <Row>
                        {loading ? <Loader /> : null}
                            <Col md={6}>
                                <Form.Group controlId="formFirstName">
                                    <Form.Label>First Name<span className="required">*</span>
                                    </Form.Label>
                                    <Form.Control type="text" required placeholder="Enter First Name" name="FirstName" value={values.FirstName}
                                        onChange={(e) => handleChange(e)} maxLength={50}
                                    />
                                    {/* {errors.FirstName ? <p className="err-msg">{errors.FirstName}</p> : null} */}

                                    <Form.Control.Feedback type="invalid">
                                        First Name is required.
                            </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Last Name<span className="required">*</span>
                                    </Form.Label>
                                    <Form.Control type="text" required placeholder="Enter Last Name" name="LastName" value={values.LastName}
                                        onChange={(e) => handleChange(e)} maxLength={50}
                                    />
                                    {/* {errors.LastName ? <p className="err-msg">{errors.LastName}</p> : null} */}

                                    <Form.Control.Feedback type="invalid">
                                        Last Name is required.
                            </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>User Name
                                        {/* <span className="required">*</span> */}
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="Enter User Name" name="UserName" value={values.UserName}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={50}
                                        disabled={true}
                                    />
                                    {/* {errors.UserName ? <p className="err-msg">{errors.UserName}</p> : null} */}

                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Mail Id
                                        {/* <span className="required">*</span> */}
                                    </Form.Label>
                                    <Form.Control type="text" placeholder="Enter Email" name="EmailID" value={values.EmailID}
                                        onChange={(e) => handleChange(e)} disabled={true} //onInput={(e) => validateEmail(e)}
                                    />
                                    {/* {errors.EmailID ? <p className="err-msg">{errors.EmailID}</p> : null} */}

                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Contact Number<span className="required">*</span>
                                    </Form.Label>
                                    <Form.Control type="text" required placeholder="Enter Contact Number" name="ContactNumber" value={values.ContactNumber}
                                        onChange={(e) => handleChange(e)} maxLength={10}
                                    />
                                    {/* {errors.ContactNumber ? <p className="err-msg">{errors.ContactNumber}</p> : null} */}
                                    <Form.Control.Feedback type="invalid">
                                        Contact Number is required.
                            </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Street</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Street" name="Street" value={values.Street}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={50}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>
                                        Role
                    {/* <span className="required">*</span> */}
                                    </Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="RoleID"
                                        type="text"
                                        value={values.RoleID}
                                        onChange={(e) => handleChange(e)}
                                        disabled={true}
                                    >
                                        <option value="" defaultValue disabled>
                                            Select Role
                    </option>
                                        {roles.length > 0 &&
                                            roles.map((role) => (
                                                <option key={role.RoleId} value={role.RoleId}>
                                                    {role.RoleName}
                                                </option>
                                            ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control type="text" placeholder="Enter City" name="City" value={values.City}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={20}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        type="text"
                                        name="Status"
                                        value={values.Status}
                                        onChange={handleChange}
                                        disabled={true}
                                    >
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName">
                                    <Form.Label>Zip Code</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Zip Code" name="ZIPCode" value={values.ZIPCode && values.ZIPCode != 0 ? values.ZIPCode : ''}
                                        onChange={(e) => handleChange(e)} maxLength={5}
                                    />
                                    {errors.ZIPCode ? <p className="err-msg">{errors.ZIPCode}</p> : null}

                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="text-right mt-2">
                                <Button variant="primary" type="submit" disabled={addSubmitDisabled}><IoMdDoneAll className="icon btn-icon" />Update</Button>
                                <Button variant="danger" type="button" className="ml-3" onClick={() => history.goBack()}><IoIosClose className="icon btn-icon" />Cancel</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            
            <Footer />
        </section>
    )
}
// Map Redux state to React component props
const mapStateToProps = state => ({
    login: state.users.login,
    loading: state.clients.loading,
    hasErrors: state.clients.hasErrors,
})
export default connect(mapStateToProps)(MyProfile);